import { RegionsIcon } from "@/components/icons";

import { REGIONS } from "./catalog.ts";
import { CatalogPanel } from "./CatalogPanel.tsx";

/**
 * Administración de regiones.
 *
 * La región deja de ser un texto libre dentro de la vinculación y pasa a ser
 * una entidad con su propia pantalla, igual que el cargo. En la vinculación se
 * elige una de las que existen, no se escribe.
 */
export function RegionsPanel() {
  return <CatalogPanel catalog={REGIONS} icon={RegionsIcon} />;
}
